module.exports = __webpack_public_path__ + "static/media/icon-saved-worksheet-grey.3e1c8e02.svg";